import { useSearchParams } from 'react-router-dom';

export function EnvironmentReminder() {
  const [searchParams] = useSearchParams();
  const hideEnv = searchParams.get('hideEnv') === 'true';

  // Get environment
  const env = process.env.REACT_APP_ENV;

  // Don't show anything if:
  // 1. hideEnv is true in URL params
  // 2. No environment is set
  // 3. We're in prod and on MilestoneMap.org
  if (
    hideEnv ||
    !env ||
    (env === 'prod' && window.location.hostname === 'milestonemap.org') ||
    (env === 'prod' && window.location.hostname === 'mm.30to80.com')
  ) {
    return null;
  }

  // Color mapping for different environments
  const colorMap: { [key: string]: string } = {
    alpha: 'bg-purple-600',
    dev: 'bg-blue-600',
    stage: 'bg-orange-600',
    prod: 'bg-red-600',
    'mm-30to80': 'bg-red-400',
  };

  const bgColor = colorMap[env] || 'bg-gray-600';

  return (
    <div className={`w-full text-center text-white text-sm py-1 ${bgColor}`}>
      {env.toUpperCase()} ENVIRONMENT
    </div>
  );
}
